import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import { Typography, Box } from '@material-ui/core';

const SCAInformation = ({ compact = false, showTitle = true }) => (
  <Box>
    {showTitle && (
      <Typography variant="h6" component="div" gutterBottom>
        <FormattedMessage
          id="sca.information.heading"
          defaultMessage="You're about to verify your identity"
        />
      </Typography>
    )}

    <Typography variant={compact ? 'body2' : 'body1'} component="span" gutterBottom>
      <FormattedMessage
        id="sca.information.intro" // To complete this process, you'll need to verify your identity through our secure provider.
        defaultMessage="You will be redirected to our secure verification provider to complete your identity check."
      />
    </Typography>
    <br />
    <Typography variant={compact ? 'body2' : 'body1'} component="span">
      <FormattedMessage
        id="sca.information.reason" // This step is required by European PSD2 regulations for Strong Customer Authentication.
        defaultMessage="This step is required to comply with financial regulations and helps us keep your account secure."
      />
    </Typography>
  </Box>
);

SCAInformation.propTypes = {
  compact: PropTypes.bool,
  showTitle: PropTypes.bool,
};

export default SCAInformation;
